// Non-game "finds" scattered in the park. Clicking one unlocks a MEMORY (no game).
export const OBJECT_FINDS = [
  { key: "kite", area: "P1", x: 73, y: 15, name: "Atki Hui Patang", need: "Patang + Manjha",
    blurb: "Woh peeli patang jo ped ki daali mein atak gayi thi — poora mohalla chhat pe chillata: 'E woh gaya… kaata!'" },
  { key: "marble", area: "P1", x: 17, y: 84, name: "Charpai ke Neeche Kancha",
    blurb: "Aakhri kancha jo charpai ke neeche chhup gaya tha. Mummy jhaadu maarti, tabhi mil jaata." },
  { key: "cassette", area: "P2", x: 49, y: 85, name: "TDK Cassette",
    blurb: "Pencil se ghuma-ghuma ke tape wapas set karte the. A-side khatam? Palat do, B-side chalao." },
  { key: "phantom", area: "P2", x: 85, y: 80, name: "Phantom Cigarette",
    blurb: "Do rupaye ki meethi sigarette. Muh mein daba ke bilkul bade aadmi wali feel aati thi." },
  { key: "coin", area: "P3", x: 19, y: 51, name: "Peetal ki Chavanni",
    blurb: "50 paise ka sikka — poori Poppins ya ek Phantom isi mein aa jaata tha." },
  { key: "pencil", area: "P3", x: 77, y: 83, name: "Nataraj Pencil",
    blurb: "Chaaku se cheelte the, aur peeche laal-kaali rubber dheere-dheere ghis jaati thi." },
];
